import { useMutation, useQueryClient } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import storage from '@/utils/storage';
import { API_URL } from '@/config';

export const updateProjectContent = async ({
  file_id,
  project_id,
  file,
  is_workflow,
}: {
  file_id: string;
  project_id: string;
  file: File;
  is_workflow: boolean;
}): Promise<any> => {
  const access_token = storage.getToken();

  if (!access_token || !project_id || !file_id) {
    return;
  }

  try {
    const formData = new FormData();
    formData.append('file', file);
    if (is_workflow !== undefined) {
      formData.append('is_workflow', String(is_workflow));
    }

    const response = await axios.patch(
      `${API_URL}/v2/project/${project_id}/contents/file/${file_id}/update-file`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const useUpdateProjectContent = (config = {}) => {
  const { addNotification } = useNotificationStore();
  const queryClient = useQueryClient();

  return useMutation<
    any,
    Error,
    {
      file_id: string;
      project_id: string;
      file: any;
      is_workflow: boolean;
    }
  >({
    mutationFn: updateProjectContent,
    onError: (error: any) => {
      addNotification({
        type: 'error',
        title: 'Failed to update file',
        message: error?.response?.data?.data,
        delay: 6000,
      });
    },
    onSuccess: (data, variables) => {
      if (data) {
        addNotification({
          type: 'success',
          title: 'File updated successfully',
        });
        queryClient.invalidateQueries(['projectContent', variables.project_id]);
      }
    },
    ...config,
  });
};
